import camera1 from '../Resources/camera1.jpg';
import baie_camera1 from '../Resources/baie_camera1.jpeg';
import camera1_terasa from '../Resources/camera1_terasa.jpg';
import cameraaa from '../Resources/camera2.jpeg';
import camera2_baie from '../Resources/camera2_baie.jpg';
import camera2_balcon from '../Resources/camera2_balcon.jpg';
import camera3 from '../Resources/camera3.jpg';
import camera3_baie from '../Resources/camera3_baie.jpg';
import camera4 from '../Resources/camera4.jpeg';

export interface Room {
  id: string;
  name: string;
  type: 'standard' | 'deluxe' | 'suite';
  description: string;
  longDescription: string;
  price: number;
  capacity: number;
  size: number;
  bed: string;
  bathroom: string;
  images: string[];
  amenities: string[];
}

export const roomsData: Room[] = [
  {
    id: 'double-room',
    name: 'Cameră Dublă',
    type: 'standard',
    description: 'Cameră confortabilă cu terasă și grădină',
    longDescription: "Camera noastră dublă oferă tot confortul de care aveți nevoie. Camera este dotată cu pat dublu confortabil, baie privată, și acces la terasă cu vedere la grădină. Bucurați-vă de facilități moderne precum WiFi gratuit, TV cu ecran plat și aer condiționat.",
    price: 200,
    capacity: 2,
    size: 15,
    bed: 'Pat Dublu',
    bathroom: 'Baie Privată',
    images: [camera1,baie_camera1,camera1_terasa,cameraaa,camera2_baie,camera2_balcon,camera3,camera3_baie,camera4
    ],
    amenities: [
      'Terasă',
      'Vedere la grădină',
      'Baie privată',
      'WiFi gratuit',
      'TV cu ecran plat',
      'Aer condiționat',
      'Parcare gratuită',
      'Grătar'
    ]
  }
];